export function getOfferPropertyId(offer: App.Offer | undefined): string | undefined {
  return offer?.packages?.find((offerPackage) => offerPackage?.fk_property_id)?.fk_property_id;
}
